import React, { useState, useEffect, useCallback } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiZoomIn, FiChevronLeft, FiChevronRight } = FiIcons;

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const images = [
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/740c17cca0db502690e5d56d7ffc06b8.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/e13503efe9566761805a90eb3c08c967.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/e674a6f215890eea3e5a88babc0ae74c.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/5b65541f83e4e10d4084cbafc929bf5d.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/9fe542f8f3fe2e1037ec9de62a354ec7.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/b9b86dd674f5aa073cd85d435e1a404e.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/3986ea6f21f5b0c1210d0cff4f2af4b7.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/64ec7aab015f08812dfb85b221335370.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/c1c6787895183f496aa934d646c57abb.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/8fdf4c70fafe5f55aaa78fdef3272c1d.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/45078475b512f949eaeddb009c8a65bd.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/53fb244fe9c12dd6df0195b9a9c27456.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/f6af55fcb6b06bec77aac57b5282d6f8.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/f421ff240e152c8e5c5782bc936daa14.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/b86d3fa4fb5bb9c9cd72005c2cd2ac14.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/d460506f701e074c786e97263dbec448.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/6e49d84468e39691005102850707e24a.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/ba27d979c16f3aea4851ca0fafe863f6.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/3d3b90ccb233d443e61ae2d6b9b193d1.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/5e9446cc49a9b029927b981eb2f77880.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/2c00d3cf6b83729d1377030f137be2a9.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/5e9655cae82a71eefe9467183f8e931c.jpg",
    "https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/6e6f12c9b4afef8ca53e96b586dd9556.jpg"
  ];

  const handlePrev = useCallback((e) => {
    e?.stopPropagation();
    setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }, [images.length]);

  const handleNext = useCallback((e) => {
    e?.stopPropagation();
    setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);

  const handleKeyDown = useCallback((e) => {
    if (selectedIndex === null) return;
    if (e.key === 'ArrowLeft') handlePrev();
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'Escape') setSelectedIndex(null);
  }, [selectedIndex, handlePrev, handleNext]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl mb-6">Gallery</h1>
          <p className="text-lg text-brand-600 max-w-2xl mx-auto">
            Glimpses of paradise at Amani Palms.
          </p>
        </div>

        {/* Masonry Layout using CSS Columns */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {images.map((src, index) => (
            <div 
              key={index} 
              className="break-inside-avoid relative group rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-300"
              onClick={() => setSelectedIndex(index)}
            >
              <img 
                src={src} 
                alt={`Gallery image ${index + 1}`} 
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                <SafeIcon icon={FiZoomIn} className="text-white text-3xl drop-shadow-md" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedIndex !== null && (
        <div 
          className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm"
          onClick={() => setSelectedIndex(null)}
        >
          {/* Close Button */}
          <button 
            className="absolute top-6 right-6 text-white/70 hover:text-white text-4xl transition-colors focus:outline-none z-[70]"
            onClick={() => setSelectedIndex(null)}
          >
            <SafeIcon icon={FiX} />
          </button>

          {/* Previous Button */}
          <button
            className="absolute left-2 md:left-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white text-4xl md:text-6xl transition-colors focus:outline-none z-[70] p-2"
            onClick={handlePrev}
          >
            <SafeIcon icon={FiChevronLeft} />
          </button>

          {/* Image */}
          <div 
            className="relative max-w-full max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={images[selectedIndex]} 
              alt={`Gallery image ${selectedIndex + 1}`} 
              className="max-w-full max-h-[85vh] md:max-h-[90vh] object-contain rounded-sm shadow-2xl select-none"
            />
            {/* Counter */}
            <div className="absolute -bottom-8 left-0 right-0 text-center text-white/60 text-sm">
              {selectedIndex + 1} / {images.length}
            </div>
          </div>

          {/* Next Button */}
          <button
            className="absolute right-2 md:right-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white text-4xl md:text-6xl transition-colors focus:outline-none z-[70] p-2"
            onClick={handleNext}
          >
            <SafeIcon icon={FiChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;